/* global jQuery */

import GA4Tracking from './utils/ga4-tracking'

export const addViewItemOnPageLoad = () => {
  const gaViewItemElement = jQuery('[data-ga-vi]')
  if (gaViewItemElement.length === 0) {
    return
  }

  let gaItem = gaViewItemElement.attr('data-ga-vi')
  gaItem = JSON.parse(gaItem)
  if (typeof gaItem !== 'object') {
    return
  }

  GA4Tracking.pushEvent('view_item', [gaItem])
}